import { Contact } from "@data-phone/react-generic/dist/components/Forms/Contacts";

export function formatContactName(contact: Contact) {
    if (!contact) {
        throw new Error("Contact is required");
    }

    return [contact.first_name, contact.middle_name, contact.last_name]
        .map(name => name && name.trim()).filter(Boolean).join(" ")
}